import React from 'react';
import { withCookies, Cookies } from 'react-cookie';

import '../../sass/cookie-footer.scss'

const COOKIE_NAME = "ntsAutechreOk";

class CookiesFooter extends React.Component {
    constructor(props) {
        super(props);

        this.hideFooter = this.hideFooter.bind(this);

        this.state = {
            displayFooter: false,
        }
    }

    componentDidMount() {
        const cookies = this.props.cookies;

        if (!cookies.get(COOKIE_NAME)) {
            this.setState({
                displayFooter: true,
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.displayFooter !== nextState.displayFooter;
    }

    hideFooter() {
        const cookies = this.props.cookies;

        const expiresDate = new Date();
        expiresDate.setTime(expiresDate.getTime() + (3.154e+10)); // expires in 1 year
        cookies.set(COOKIE_NAME, 'true', {
            expires: expiresDate,
        });

        this.setState({
            displayFooter: false,
        });
    }

    render() {
        const displayFooterClass = this.state.displayFooter ? 'cookie-footer--show' : '';
        return (
            <div id="cookie-footer" className={displayFooterClass}>
                <span className="cookie-footer__label">We store and access cookies for analytic purposes. By using this site, you are giving NTS and Warp your consent to use cookies.</span>
                <span className="cookie-footer__btn text-uppercase text-bold cursor-pointer no-text-select" onClick={this.hideFooter}>OK</span>
            </div>
        )
    }
}

export default withCookies(CookiesFooter);



// WEBPACK FOOTER //
// ./src/components/CookiesFooter.jsx